'use client';

import { Box, Container, Typography, Stack, Link as MuiLink } from '@mui/material';
import Link from 'next/link';
import { MakerMarketplaceLogoLink } from 'components/brand/MakerMarketplaceLogoLink';

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: 'background.paper', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(4, 1fr)',
            },
            gap: 4,
          }}
        >
          {/* Company Info */}
          <Stack spacing={2}>
            <MakerMarketplaceLogoLink height={56} />
            <Typography variant="body2" color="text.secondary">
              Connecting designers and manufacturers across the UK
            </Typography>
          </Stack>

          {/* Services */}
          <Stack spacing={2}>
            <Typography variant="h6" color="text.primary">
              Services
            </Typography>
            <Stack spacing={1}>
              <MuiLink component={Link} href="/jobs?type=design" color="text.secondary">
                Design Services
              </MuiLink>
              <MuiLink component={Link} href="/jobs?type=manufacturing" color="text.secondary">
                Manufacturing
              </MuiLink>
              <MuiLink component={Link} href="/jobs" color="text.secondary">
                Browse All Jobs
              </MuiLink>
            </Stack>
          </Stack>

          {/* Company */}
          <Stack spacing={2}>
            <Typography variant="h6" color="text.primary">
              Company
            </Typography>
            <Stack spacing={1}>
              <MuiLink component={Link} href="/about" color="text.secondary">
                About Us
              </MuiLink>
              <MuiLink component={Link} href="/how-it-works" color="text.secondary">
                How It Works
              </MuiLink>
              <MuiLink component={Link} href="/contact" color="text.secondary">
                Contact
              </MuiLink>
            </Stack>
          </Stack>

          {/* Legal */}
          <Stack spacing={2}>
            <Typography variant="h6" color="text.primary">
              Legal
            </Typography>
            <Stack spacing={1}>
              <MuiLink component={Link} href="/privacy" color="text.secondary">
                Privacy Policy
              </MuiLink>
              <MuiLink component={Link} href="/terms" color="text.secondary">
                Terms of Service
              </MuiLink>
              <MuiLink component={Link} href="/cookies" color="text.secondary">
                Cookie Policy
              </MuiLink>
            </Stack>
          </Stack>
        </Box>

        <Box sx={{ mt: 6, pt: 3, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} Maker Marketplace. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
